<template>
  <div>
    <transition
      :name="transition"
      mode="out-in"
      @after-leave="scrollToTop()"
    >
      <component
        :key="currentStep"
        ref="currentStep"
        class="step-component"
        :is="currentStep"
        @next="nextStep($event)"
      />
    </transition>

    <AppProgressCircles
      :index="circleProgress"
    />

    <AppPopupTimeout
      timer-mins="11"
      timer-storage-key="post-app-timer"
      :current-step="currentStep"
      @timer-finished="redirectToFinished"
    />
  </div>
</template>

<script>
/**
 * <step-handler-documents></step-handler-documents>
 * @desc Handles the step order logic for the documents page
 */

import AppPopupTimeout from '@/components/common/popups/AppPopupTimeout'
import AppProgressCircles from '@/components/common/notifications/AppProgressCircles'
import UploadDriversLicense from './steps/UploadDriversLicense'
import UploadPayStub from './steps/UploadPayStub'
import postAppProgress from '@/mixins/post-app-progress'
import submit from '@/mixins/submit'

export default {
  // Name
  name: 'step-handler-documents',

  // Components
  components: {
    AppPopupTimeout,
    AppProgressCircles,
    UploadDriversLicense,
    UploadPayStub
  },

  // Mixins
  mixins: [postAppProgress, submit],

  // Data
  data () {
    return {
      currentStep: 'UploadDriversLicense',
      stepIndex: 0,
      lastStep: undefined,
      transition: 'step-next',
      steps: {
        'UploadDriversLicense': {
          next: () => 'UploadPayStub'
        },

        'UploadPayStub': {}
      }
    }
  },

  // Computed
  computed: {
    circleProgress () {
      return this.shouldShowIncomeChanger
        ? this.stepIndex + 3
        : this.stepIndex + 2
    }
  },

  // Created
  created () {
    if (history.state.currentStep === 'UploadPayStub' && this.submittedDocuments) {
      this.transition = undefined
      this.currentStep = history.state.currentStep
      this.stepIndex = history.state.stepIndex
    } else {
      history.replaceState({
        currentStep: this.currentStep,
        previousStep: this.previousStep,
        stepIndex: this.stepIndex
      }, this.currentStep)
    }
  },

  // Mounted
  mounted () {
    this.setPopstateListener()
  },

  destroyed () {
    window.removeEventListener('popstate', this.handlePopstate)
  },

  // Methods
  methods: {
    async nextStep () {
      try {
        this.transition = 'step-next'
        const nextStep = this.steps[this.currentStep].next()
        this.stepIndex++
        window.history.pushState({
          currentStep: nextStep,
          stepIndex: this.stepIndex
        }, this.currentStep)

        this.currentStep = nextStep
      } catch (error) {
        console.warn(error)
      }
    },

    async handlePopstate (event) {
      const eventIndex = event.state.stepIndex

      if (eventIndex > this.stepIndex) {
        try {
          // await this.validateStep(this.$refs.currentStep)
          this.transition = 'step-next'
          this.stepIndex = eventIndex
          this.currentStep = event.state.currentStep
        } catch (error) {
          console.warn(error.message)
        }
      } else {
        this.transition = 'step-prev'
        this.stepIndex = eventIndex
        this.currentStep = event.state.currentStep
      }
    },

    // Listen for popstate events, Update currentStep accordingly
    setPopstateListener () {
      window.addEventListener('popstate', this.handlePopstate, false)
    },

    scrollToTop () {
      if (this.transition !== 'step-next') return
      this.$nextTick(() => {
        window.scrollTo(0, 0)
      })
    },

    redirectToFinished () {
      this.$router.replace({
        path: '/finished',
        query: { ...this.$route.query }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.step-component {
  @include breakpoint('desktop-up') {
    max-width: 1000px;
    min-width: 1000px;
    margin: auto;
  }
}

.app-progress-circles {
  margin-top: -20px;
}
</style>
